/**
 * @generated SignedSource<<a8dfd7d493ccb0cee6528546a9bc57bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanyFilterCompaniesQuery$variables = {
  query?: string | null;
};
export type CompanyFilterCompaniesQuery$data = {
  readonly recordingsCompanies: ReadonlyArray<string>;
};
export type CompanyFilterCompaniesQuery = {
  response: CompanyFilterCompaniesQuery$data;
  variables: CompanyFilterCompaniesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "query"
      }
    ],
    "kind": "ScalarField",
    "name": "recordingsCompanies",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyFilterCompaniesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyFilterCompaniesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88446163cdb5c801f63a3c0cbbaea80d",
    "id": null,
    "metadata": {},
    "name": "CompanyFilterCompaniesQuery",
    "operationKind": "query",
    "text": "query CompanyFilterCompaniesQuery(\n  $query: String\n) {\n  recordingsCompanies(search: $query)\n}\n"
  }
};
})();

(node as any).hash = "8773da524af96d20f94e75d8cececf3f";

export default node;
